import { useEffect, useState } from 'react'
import BenchmarkApplicantCard from './BenchmarkApplicantCard'
import { Box, Button, Collapse, Divider, FormControl, MenuItem, Select, Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { Applicant } from 'store/dashboard/types'
import SectionContainer from '../../../components/SectionContainer'
import SectionHeader from '../../../components/SectionHeader'
import OpenCloseButton from 'components/openCloseButton/OpenCloseButton'
import { useParams } from 'react-router-dom'
import BenchmarkReportForMultisector from 'containers/dashboard/multisectorReport/sections/benchmarkSection/BenchmarkReportForMultisector'

type Props = {
  target: Applicant
  subgroups: string[]
  benchmarkApplicants: Applicant[]
  setBenchmarkApplicants: (applicants: Applicant[]) => void
  topCompaniesNumber: number
  addTopCompanies: () => void
}

export default function BenchmarkSection({
  target,
  subgroups,
  benchmarkApplicants,
  setBenchmarkApplicants,
  topCompaniesNumber,
  addTopCompanies,
}: Props) {
  const params = useParams<{ id: string }>()
  const id = params?.id || ''
  const [sectionOpened, setSectionOpened] = useState(true)
  const [numOfapplicantsToDisplay, setNumOfapplicantsToDisplay] = useState(9)
  const greyColor = 'normalGrey.main'

  const getKey = (app: Applicant) => app.applicant_original_name + app.comparison_score + app.subgroup
  const removeApplicant = (applicant: Applicant) => {
    const updated = benchmarkApplicants.filter(a => a.applicant_cleaned !== applicant.applicant_cleaned)
    setBenchmarkApplicants(updated)
  }
  function FiltersComponent() {
    return (
      <Stack direction="row" alignItems="center">
        <FormControl size="small">
          <Select value={1} sx={{ color: 'primary.main' }} labelId="ip-weight" name="top-results-filters" onChange={() => {}}>
            <MenuItem id="1" value={1}>
              IP Weight
            </MenuItem>
          </Select>
        </FormControl>
        <Typography px={2}>+</Typography>
        <FormControl size="small" sx={{ ml: 0 }}>
          <Select labelId="share-price" name="spotlight-filters" value={1} sx={{ color: 'primary.main' }}>
            <MenuItem value={1}>Share Price (p)</MenuItem>
          </Select>
        </FormControl>
      </Stack>
    )
  }

  return (
    <SectionContainer>
      <SectionHeader title="Benchmark" justifyContent={'left'}>
        <Box width={'100%'} display={'flex'} justifyContent={'space-between'} alignItems="center">
          <Typography fontWeight={400}>
            <Typography component="span" color="primary">
              {benchmarkApplicants.length} {''}
            </Typography>
            companies added
          </Typography>
          <Stack direction="row" alignItems="center">
            <OpenCloseButton onClick={() => setSectionOpened(!sectionOpened)} opened={sectionOpened} />
          </Stack>
        </Box>
      </SectionHeader>
      <Collapse in={sectionOpened}>
        <Box px={3} pb={3}>
          <Box display={'flex'} justifyContent="space-between" alignItems="center" mb={3}>
            <Button onClick={addTopCompanies} variant="contained" color="primary">
              Add top {topCompaniesNumber}
            </Button>
            <FiltersComponent />
          </Box>

          <Grid container spacing={4} columns={{ sm: 12, md: 12, lg: 10, xl: 12 }}>
            <Grid size={{ xs: 6, sm: 6, md: 4, lg: 2, xl: 2 }} key={getKey(target)}>
              <BenchmarkApplicantCard applicant={target} target={true} removeApplicant={removeApplicant} />
            </Grid>
            {benchmarkApplicants.slice(0, numOfapplicantsToDisplay).map((applicant, index) => {
              return (
                <Grid size={{ xs: 6, sm: 6, md: 4, lg: 2, xl: 2 }} key={getKey(applicant)}>
                  <BenchmarkApplicantCard applicant={applicant} removeApplicant={removeApplicant} />
                </Grid>
              )
            })}
          </Grid>
          {benchmarkApplicants.length > numOfapplicantsToDisplay && (
            <Box mt={5} display={'flex'} justifyContent="right" alignItems="center" sx={{ textAlign: 'center' }}>
              <Typography color={greyColor}> Expand to see next 10 companies </Typography>
              <OpenCloseButton onClick={() => setNumOfapplicantsToDisplay(numOfapplicantsToDisplay + 10)} opened={false} />
            </Box>
          )}
        </Box>
        <Divider />
        <Box px={3} pt={4} pb={4}>
          <BenchmarkReportForMultisector
            id={id}
            name={target.applicant_original_name}
            ipcrCodes={subgroups}
            companyNames={[target.applicant_original_name].concat(benchmarkApplicants.map(app => app.applicant_original_name))}
          />
        </Box>
      </Collapse>
    </SectionContainer>
  )
}
